import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../config/Api";
import { Category } from "../../types/category";

export interface CreateCategoryPayload {
  name: string;
  categoryId: string;
  level: number;
  parentCategoryId?: string;
}

export const createCategory = createAsyncThunk<Category, CreateCategoryPayload>(
  "category/createCategory",
  async (categoryData, { rejectWithValue }) => {
    try {
      const cleanedData = {
        ...categoryData,
        parentCategoryId: categoryData.parentCategoryId?.trim() ? categoryData.parentCategoryId : null,
      };

      const response = await api.post("/api/admin/categories", cleanedData);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create category"
      );
    }
  }
);